var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 312.808,
    width: 224.225,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6703.887 2747.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10.63,
    rx: 10.63,
    width: 223.228,
    height: 311.811,
    x: 6704.386,
    y: -2746.811,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.997
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6739.206-2691.764c9.92-9.682 16.436-20.238 22.667-30.39 5.465 11.17 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.917-6.267-10.795-12.866-20.571-22.694-29.917zM6739.206-2492.917c9.92-9.682 16.436-20.238 22.667-30.39 5.465 11.17 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.917-6.267-10.795-12.866-20.571-22.694-29.917zM6850.739-2691.764c9.92-9.682 16.436-20.238 22.667-30.39 5.464 11.17 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.917-6.268-10.795-12.866-20.571-22.694-29.917zM6850.739-2492.917c9.92-9.682 16.436-20.238 22.667-30.39 5.464 11.17 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.917-6.268-10.795-12.866-20.571-22.694-29.917zM6899.928-2498.107c4.064-3.966 6.733-8.29 9.285-12.449 2.239 4.576 5.451 8.58 8.925 12.449-3.717 3.838-6.598 7.941-8.914 12.255-2.567-4.422-5.27-8.427-9.296-12.255zM6712.71-2683.22c4.063-3.966 6.732-8.29 9.285-12.448 2.238 4.575 5.45 8.579 8.924 12.448-3.717 3.838-6.597 7.942-8.913 12.256-2.568-4.422-5.27-8.427-9.297-12.256zM6722.221-2700.437v-2.813h2.585v-4.636h-12.925v-3.271l13.985-21.099 2.286.008v21.09h3.953v3.272h-3.953l-.076 4.636h2.166v2.813zm2.585-24.097l-8.879 13.377h8.88zM6909.778-2481.374v2.813h-2.585v4.636h12.925v3.271l-13.985 21.099-2.285-.008v-21.09h-3.953v-3.272h3.953l.076-4.636h-2.167v-2.813zm-2.585 24.097l8.88-13.377h-8.88z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4D);
export default __webpack_public_path__ + "static/media/4D.774e7a3257b1913d02e052e5a6dbcb6c.svg";
export { ForwardRef as ReactComponent };